(() => {
  window.swinger.eventHub.register('dragstart', '.swinger-draganddrop-source', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const effect = elem.getAttribute('data-draganddrop-effect') || 'move';
    const data = elem.getAttribute('data-draganddrop-data');

    document.documentElement.classList.add('is-dragging');

    e.dataTransfer.setData('application/swinger-draganddrop', data);
    e.dataTransfer.effectAllowed = effect;
  });

  window.swinger.observer.initialize('.swinger-draganddrop-source [draggable]', (elem) => {
    elem.removeAttribute('draggable');
  });

  window.swinger.eventHub.register('dragend', '.swinger-draganddrop-source', () => {
    document.documentElement.classList.remove('is-dragging');
  });
})();
